
import { Component, Prop, Vue } from 'vue-property-decorator';

import { PaymentReceiptModal } from './components/PaymentReceiptModal';
import { DepositModal } from './components/DepositModal';
import { WithdrawModal } from './components/WithdrawModal';
import { LegacyTransferModal } from './components/LegacyTransferModal';
import { TransferWithdrawalModal } from './components/TransferWithdrawalModal';
import { OrderModal } from '@/modules/transaction/components/OrderModal';
import { ChargingFeesModal } from './components/ChargingFeesModal';
import { ExchangeTransferModal } from './components/ExchangeTransferModal';
import { PortabilityModal } from './components/PortabilityModal';

@Component({
  components: {
    PaymentReceiptModal,
    DepositModal,
    WithdrawModal,
    LegacyTransferModal,
    OrderModal,
    ChargingFeesModal,
    PortabilityModal,
    ExchangeTransferModal,
    TransferWithdrawalModal
  }
})
export default class TransactionModal extends Vue {
  @Prop({ type: String, default: '' })
  private type!: string;

  @Prop({ type: String, required: true })
  private id!: string;

  @Prop({ type: Boolean, default: false })
  private isOpen!: boolean;

  private get computedAs() {
    switch (this.type.toLocaleLowerCase()) {
      case 'payment':
        return 'PaymentReceiptModal';
      case 'invoice':
        return 'DepositModal';
      case 'deposit':
        return 'DepositModal';
      case 'withdraw':
        return 'WithdrawModal';
      case 'transfer':
        return 'TransferWithdrawalModal';
      case 'withdrawtransfer':
        return 'TransferWithdrawalModal';
      case 'investmenttransfer':
        return 'LegacyTransferModal';
      case 'tradeinvestmenttransfer':
        return 'LegacyTransferModal';
      case 'tradewithdrawtransfer':
        return 'LegacyTransferModal';
      case 'order':
        return 'OrderModal';
      case 'chargingfees':
        return 'ChargingFeesModal';
      case 'asset_transfer':
        return 'PortabilityModal';
      case 'exchangetransfer':
        return 'ExchangeTransferModal';
      default:
        return '';
    }
  }
}
